'use client'

import { useEffect, useRef } from 'react'

export const usePrevState = <T>(state: T) => {
  const ref = useRef<T>(state)

  useEffect(() => {
    ref.current = state
  })

  return ref.current
}
